import { findPersona } from "./demo/data.js";
import { fromHash, transition, viewHash } from "./demo/state.js";
import { journalView } from "./demo/render.js";
const root = document.querySelector("#public-demo");
const id = root?.dataset.persona;
// This entry point deliberately has no account, repository, sync, mutation or API imports.
if (findPersona(id)) {
  let state = fromHash(id, location.hash);
  function render(focus) {
    root.innerHTML = journalView(state);
    if (focus) root.querySelector(focus)?.focus({ preventScroll: true });
  }
  function send(event, focus) {
    const next = transition(state, event);
    if (next === state) return;
    state = next;
    // Only public navigation goes in the URL. Search text is never put into a URL.
    if (viewHash(state) !== location.hash)
      history.pushState(null, "", viewHash(state));
    render(focus);
  }
  if (location.hash) render();
  window.addEventListener("popstate", () => {
    state = fromHash(id, location.hash);
    render();
  });
  root.addEventListener("submit", (e) => {
    if (e.target.id !== "demo-search") return;
    e.preventDefault();
    const data = new FormData(e.target);
    send(
      { type: "search", query: data.get("query"), where: data.get("where") },
      "#demo-search input",
    );
  });
  const dialog = document.querySelector("#demo-invite");
  root.addEventListener("click", (e) => {
    const button = e.target.closest("button[data-action]");
    if (!button || button.disabled) return;
    const { action, value } = button.dataset;
    if (action === "invite") {
      dialog.showModal();
      return;
    }
    if (action === "open-day") {
      state = transition(state, { type: "view", value: "calendar" });
      state = transition(state, { type: "scale", value: "day" });
      send({ type: "day", value }, "#demo-content");
      document
        .querySelector("#demo-content")
        .scrollIntoView({ block: "start" });
      return;
    }
    if (action === "clear") {
      send({ type: "search" }, "#demo-search input");
      return;
    }
    send(
      {
        type: action,
        value: ["move", "page", "dailyPage"].includes(action)
          ? Number(value)
          : value,
      },
      `[data-action="${action}"][data-value="${value}"]:not(:disabled)`,
    );
    // Pagination buttons may become disabled at a boundary; leave keyboard focus in content.
    if (document.activeElement === document.body)
      root.querySelector("#demo-content")?.focus({ preventScroll: true });
  });
  dialog
    .querySelector("[data-close]")
    .addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (
        e.clientX < r.left ||
        e.clientX > r.right ||
        e.clientY < r.top ||
        e.clientY > r.bottom
      )
        dialog.close();
    }
  });
}
